import React, { Component } from 'react';

import { closeOutline as close, downloadOutline, trashBinOutline as remove } from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonSpinner,
  IonModal,
} from '@ionic/react';

import PrescriptionRequestService from '../../services/prescriptionRequest';

const STATUS_COLORS = {
  pending: 'warning',
  in_elaboration: 'primary',
  confirmed: 'success',
  delivered: 'tertiary',
  cancelled: 'danger',
};

class PrescriptionRequestDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      request: null,
      loading: true,
      filePreview: null,
    };
  }

  async ionViewWillEnter() {
    await this.loadRequest();
  }

  async loadRequest() {
    this.setState({ loading: true });
    try {
      const id = this.props.match.params.id;
      const { data } = await PrescriptionRequestService.get(id);
      this.setState({ request: data.data || data });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loading: false });
    }
  }

  async handleDelete() {
    const { request } = this.state;
    if (!request || request.status !== 'pending') return;

    try {
      await PrescriptionRequestService.remove(request.id);
      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Ricetta cancellata',
          color: 'success',
        });
      }

      this.props.history.push('/app/prescription-request/list');
    } catch (error) {
      console.error(error);

      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Impossibile cancellare la ricetta',
          color: 'warning',
        });
      }
    }
  }

  async handlePreviewFile(fileObject) {
    const id = this.props.match.params.id;

    try {
      const blob = await PrescriptionRequestService.downloadFile(id);
      const blobUrl = URL.createObjectURL(blob);

      this.setState({
        filePreview: {
          ...fileObject,
          blobUrl,
          name: fileObject.name || 'file',
          type: fileObject.type || blob.type || 'application/octet-stream',
        },
      });
    } catch (error) {
      console.error(error);

      if (this.props.toast && this.props.toast.current) {
        this.props.toast.current.add({
          message: 'Impossibile caricare il file',
          color: 'warning',
        });
      }
    }
  }

  componentWillUnmount() {
    if (this.state.filePreview && this.state.filePreview.blobUrl) {
      URL.revokeObjectURL(this.state.filePreview.blobUrl);
    }
  }

  formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);

    return d.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  render() {
    const { request, loading, filePreview } = this.state;

    if (loading) {
      return (
        <IonContent>
          <div className="ion-padding ion-text-center">
            <IonSpinner />
          </div>
        </IonContent>
      );
    }

    if (!request) {
      return (
        <IonContent>
          <div className="ion-padding ion-text-center">
            <p>Ricetta non trovata</p>
            <IonButton onClick={() => this.props.history.push('/app/prescription-request/list')}>
              Torna alla lista
            </IonButton>
          </div>
        </IonContent>
      );
    }

    const fileObject = request.file && typeof request.file === 'object' ? request.file : null;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/prescription-request/list" />
            </IonButtons>

            <IonTitle>Dettaglio Ricetta</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonList lines="full" className="ion-no-margin">
            <IonItem>
              <IonLabel>
                <h2>Tipo</h2>
                <p>{request.type_label || request.type}</p>
              </IonLabel>

              <IonBadge color={STATUS_COLORS[request.status] || 'medium'} slot="end">
                {request.status_label || request.status}
              </IonBadge>
            </IonItem>

            <IonItem>
              <IonLabel>
                <h2>Codice Fiscale</h2>
                <p>{request.codice_fiscale}</p>
              </IonLabel>
            </IonItem>

            {request.nre && (
              <IonItem>
                <IonLabel>
                  <h2>NRE</h2>
                  <p>{request.nre}</p>
                </IonLabel>
              </IonItem>
            )}

            {request.fse_consent && (
              <IonItem>
                <IonLabel>
                  <h2>Consenso FSE</h2>
                  <p>Consenso fornito per il prelievo delle ricette dal Fascicolo Sanitario</p>
                </IonLabel>
              </IonItem>
            )}

            {request.file && fileObject && (
              <IonItem detail onClick={() => this.handlePreviewFile(fileObject)}>
                <IonLabel>
                  <h2>File caricato</h2>
                  <p>{fileObject.name || 'Visualizza file'}</p>
                </IonLabel>

                <IonIcon slot="end" icon={downloadOutline} />
              </IonItem>
            )}

            {request.equivalent && (
              <IonItem>
                <IonLabel>
                  <h2>Farmaco equivalente</h2>
                  <p>Si accetta farmaco equivalente</p>
                </IonLabel>
              </IonItem>
            )}

            {request.note && (
              <IonItem>
                <IonLabel className="ion-text-wrap">
                  <h2>Note</h2>
                  <p>{request.note}</p>
                </IonLabel>
              </IonItem>
            )}

            {request.pharmacy_note && (
              <IonItem lines="none" className="ion-margin-top">
                <IonLabel className="ion-text-wrap">
                  <h2 style={{ color: 'var(--ion-color-primary)' }}>Risposta della farmacia</h2>
                  <p>{request.pharmacy_note}</p>

                  {request.pharmacy_updated_at && (
                    <p className="ion-padding-top">
                      <small>Aggiornato il {this.formatDate(request.pharmacy_updated_at)}</small>
                    </p>
                  )}
                </IonLabel>
              </IonItem>
            )}

            <IonItem>
              <IonLabel>
                <p>
                  <small>Inviata il {this.formatDate(request.created_at)}</small>
                </p>
              </IonLabel>
            </IonItem>
          </IonList>

          {request.status === 'pending' && (
            <div className="ion-padding">
              <IonButton expand="block" color="warning" onClick={() => this.handleDelete()}>
                <IonIcon slot="start" icon={remove} /> Cancella ricetta
              </IonButton>
            </div>
          )}
        </IonContent>

        {filePreview && (
          <IonModal isOpen={!!filePreview} onDidDismiss={() => this.setState({ filePreview: null })}>
            <IonHeader>
              <IonToolbar>
                <IonTitle>{filePreview.name || 'File'}</IonTitle>
                <IonButtons slot="end">
                  <IonButton onClick={() => this.setState({ filePreview: null })}>
                    <IonIcon icon={close} />
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
              {filePreview.type && filePreview.type.startsWith('image/') && filePreview.blobUrl ? (
                <img
                  src={filePreview.blobUrl}
                  alt={filePreview.name}
                  style={{ width: '100%', maxWidth: '600px', display: 'block', margin: '0 auto' }}
                />
              ) : filePreview.blobUrl ? (
                <IonButton expand="block" href={filePreview.blobUrl} download={filePreview.name || 'file'}>
                  <IonIcon icon={downloadOutline} slot="start" /> Scarica {filePreview.name || 'file'}
                </IonButton>
              ) : (
                <p>Anteprima non disponibile</p>
              )}
            </IonContent>
          </IonModal>
        )}
      </>
    );
  }
}

export default withIonLifeCycle(PrescriptionRequestDetail);
